// extracted by mini-css-extract-plugin
export default {"custom_modal":"modal_custom_modal__zTE7X","open":"modal_open__221Dd"};